import styled from "styled-components";

export const Inner = styled.div`
	margin-top: 1.5rem;
`;
export const Buttons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: right;
	& button {
		margin-left: 20px !important;
	}
`;
